<template>
  <div>
    <ts-loading-banner :loading="loading">
    <div class="row form-group" style="height: 600px;">
      <div class="col-md-12">
        <table>
          <tbody>
            <tr v-for="(item, index) in comments" :key="index">
              <td class="ts-py-1">
                <ts-checkbox v-model="item.checked" :disabled="!item.checked && disabledComment" @change="commentSelected">{{ item.label }}</ts-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </ts-loading-banner>
  </div>
</template>

<script>

export default {
  name: 'clickComment',
  props: ['value', 'comments'],
  data() {
    return {
      loading: false,
      model: {},
    }
  },
  computed: {
    disabledComment() {
      return this.comments.filter(comment => comment.checked).length == 5
    }
  },
  created() {
  this.model = this.value
  this.initializeComments()
  },
  methods: {
    initializeComments() {
      this.comments.forEach(comment => {
        comment.checked = this.model.comments.includes(comment.label);
      });
    },
    commentSelected() {
      this.model.comments = this.comments
        .filter(comment => comment.checked)
        .map(comment => `<p>${comment.label}</p>`)
        .join('');
    }
  }
}
</script>
